export default __webpack_public_path__ + "5957255d7e1ba3e34b266208e2654d1d.png";